import React, { useRef, useState, useEffect } from "react";
import { View, TouchableOpacity, Image, Text } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import ExploreOutfits from "./exploreOutfits";
import OutfitSilder from "./outfitSilder";

const ChatCarouselCop = ({ data, _exploreLookCommonModalRef }) => {
    const _exploreOutfitsRef = useRef();
    const _outfitSilderRef = useRef([]);
    const showExploreOutfits = () => {
        _exploreOutfitsRef.current?.show();
    };
    const hideExploreOutfits = () => {
        _exploreOutfitsRef.current?.hide();
    };

    return (
        <React.Fragment>
            {/* Outfit Slider */}
            {data.slice(0, 3).map((item,index) => (
                <React.Fragment key={item.id}>
                    <OutfitSilder  item={item} _exploreLookCommonModalRef={_exploreLookCommonModalRef} index={index} />
                </React.Fragment>
            ))}
            {data.length > 3 && (
                <>
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: spH(20),
                        }}
                    >
                        <Text
                            onPress={showExploreOutfits}
                            style={{
                                fontSize: fp(16),
                                fontWeight: "500",
                                color: "black",
                                textDecorationLine: "underline",
                                fontFamily: "JosefinSans",
                            }}
                        >
                            View More
                        </Text>
                    </View>
                    <ExploreOutfits
                        _exploreLookCommonModalRef={_exploreLookCommonModalRef}
                        outfitSlider={OutfitSilder}
                        ref={_exploreOutfitsRef}
                        data={data}
                    />
                </>
            )}
        </React.Fragment>
    );
};

export default ChatCarouselCop;
